import React from 'react';
import LocationTemplate from './LocationTemplate';

const LeggettPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Leggett"
      stateName="North Carolina"
      countyName="Edgecombe"
      zipCodes={["27846"]}
      latitude={36.035}
      longitude={-77.5828}
      population={60}
      historicalFact="Incorporated in 1911, named after a local family."
      nearbyTowns={[
        "Enfield, NC",
        "Halifax, NC",
        "Speed, NC",
        "Rocky Mount, NC",
        "Tarboro, NC",
        "Whitakers, NC",
        "Scotland Neck, NC",
        "Hobgood, NC"
      ]}
    />
  );
};

export default LeggettPage;